import { Injectable } from '@angular/core';
import * as Rx from 'rxjs';
import { tap, map } from 'rxjs/operators';
import { NotificationAPIService, INotification } from './notification-api.service';
import { UserInfoService } from '../user/user-info.service';


@Injectable({
	providedIn: 'root'
})
export class NotificationService {
	notificationChanged: any = new Rx.BehaviorSubject<number>(null);
	private notificationTotal: number = 0;
	private notificationInterval: any = null;
	private downloading: boolean = false;
	notifications: INotification[] = [];

	constructor(
		private notificationAPI: NotificationAPIService,
		private userInfo: UserInfoService
	) {
		localStorage.setItem("NotificationTotal", "0");
		// check notificaiton immediatly
		this.checkNotification();
		this.watchAccountChange();
		// check notification every 3 minute
		this.notificationInterval = window.setInterval(() => {
			this.checkNotification();
		}, 180000);
	}

	ngOnDestroy() {
		if (this.notificationInterval != null) {
			window.clearInterval(this.notificationInterval);
		}
		if (this.accountWatcher) {
			this.accountWatcher.unsubscribe();
		}
	}
	
	private accountWatcher: Rx.Subscription = null;
	private watchAccountChange(): void {
		//watch account change
		this.accountWatcher = this.userInfo.UserInfoTimestamp.subscribe({
			next: () => {
				// if account changed, update notification immediatly
				this.checkNotification();
			},
			error: (err: any) => {
				console.log(err);
			}
		});
	}

	public updateNotification(): void {
		localStorage.setItem("NotificationTotal", this.notificationTotal.toString());
		let v:number = this.notificationChanged.getValue();
		this.notificationChanged.next((v == null? 0 : v) + 1);
	}

	private checkNotification() {
		if (this.downloading) {
			return;
		}
		this.downloading = true;
		if (this.userInfo.isAnonymous()) {
			this.notificationTotal = 0;
			this.updateNotification();
			this.downloading = false;
		}
		else {
			this.notificationAPI.getNotifications(1, 0).subscribe({
				next: (response) => {
					this.notificationTotal = response.length;
					this.updateNotification();
					this.downloading = false;
				},
				error: (err) => {
					console.log(err);
					this.downloading = false;
				}
			});
		}
	}

	public downloadNotifications(): Rx.Observable<any> {
		this.notifications = [];
		return this.notificationAPI
			.getNotifications(100, 0)
			.pipe(
				map(
					(response) => {
						this.notifications = response;
						return true;
					}
				)
			);
	}

	public deleteJobPost(jobPostId: string): Rx.Observable<any> {
		let j: INotification = this.notifications.find(x => x.JobPostId == jobPostId && x.NotificationId == "8");
		if (j != undefined && j != null) {
			return this.notificationAPI
				.deleteNotification(j.NotificationPersonId)
				.pipe(tap(() => { this.checkNotification(); }));
		}
		else {
			return Rx.of(null);
		}
	}
}
